export function LoadingSpinner({
  fullScreen,
}: {
  minHeight?: string;
  size?: string;
  fullScreen?: boolean;
} = {}) {
  if (fullScreen) {
    return (
      <div className="flex min-h-[100vh] flex-col items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-[6px] border-lime-400 border-t-lime-800" />
      </div>
    );
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-[6px] border-lime-400 border-t-lime-800" />
    </div>
  );
}
